import React from "react";
import assign from "lodash/assign";
import BaseOverlay from "./base.jsx";
import { Navigation } from "react-router";
import Carousel from "nuka-carousel";
import TicketSlide from "../partials/ticket-slide.jsx";

import statics from "alt-utils/lib/statics";
import connectToStores from "alt-utils/lib/connectToStores";
import TicketStore from "../../stores/TicketStore";
import TicketActions from "../../actions/TicketActions";

export default statics(
  {
    willTransitionTo({ params }, replace, callback) {
      TicketActions.fetchAll();
      callback();
    }
  },

  @connectToStores
  class BuyTicketsOverlay extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        tickets: [],
        ticketIndex: 0,
        hasCanceled: false
      };

      this.refreshTicket = this.refreshTicket.bind(this);
      this.cancel = this.cancel.bind(this);
    }

    static getStores() {
      return [TicketStore];
    }

    static get contextTypes() {
      return {
        router: React.PropTypes.object.isRequired
      };
    }

    static getPropsFromStores() {
      return {
        getTicketsByEventId: TicketStore.getTicketsByEventId,
        tickets: TicketStore.getState().tickets
      };
    }

    componentDidMount() {
      this.componentWillReceiveProps(this.props);
      this.refreshTicketInterval = setInterval(this.refreshTicket, 2000);
    }

    componentWillReceiveProps(props) {
      let tickets = props.getTicketsByEventId(props.params.eventId);

      // *All* tickets have been deleted since the last refresh
      if (this.state.tickets.length && tickets.length === 0) {
        this.cancel();
        return;
      }

      // If no tickets have been added/deleted, don't change the original sort order, just update
      // in place with the new items. This is a little hacky, but needed to preserve the order.
      if (this.state.tickets.length === tickets.length) {
        let updated = this.state.tickets.map(t => {
          return props.tickets[t.id];
        });
        this.setState({ tickets: updated });
        return;
      }

      // Sort tickets, first created to most recently. Also place tickets that have already
      // been scanned at the end of the list.
      tickets.sort((a, b) => {
        if (a.used_at && !b.used_at) {
          return 1;
        }
        if (!a.used_at && b.used_at) {
          return -1;
        }
        if (a.used_at && b.used_at) {
          return a.used_at - b.used_at;
        }
        return a.created_at - b.created_at;
      });

      // If the last ticket has been deleted, reset index
      if (!tickets[this.state.ticketIndex]) {
        this.setState({ ticketIndex: tickets.length - 1 });
      }

      this.setState({ tickets: tickets });
    }

    componentWillUnmount() {
      clearInterval(this.refreshTicketInterval);
    }

    refreshTicket() {
      let { tickets, ticketIndex } = this.state;
      TicketActions.fetchOne(this.state.tickets[ticketIndex].id);
    }

    cancel() {
      if (this.state.hasCanceled) {
        return;
      }

      if (
        this.props.location.state &&
        this.props.location.state.fromTicketButton
      ) {
        // Go back to wherever the ticket button was (don't just dump out on tickets listing)
        this.context.router.goBack();
      } else {
        this.context.router.push("/tickets");
      }

      this.setState({ hasCanceled: true });
    }

    render() {
      let { tickets, ticketIndex } = this.state;

      return tickets.length ? (
        <BaseOverlay onRequestClose={this.cancel}>
          <div style={{ textAlign: "center", fontWeight: "bold" }}>
            Present this QR code at the door.
            <br />
            Swipe for multiple tickets (ticket #{ticketIndex + 1}/
            {tickets.length}).
          </div>
          <Carousel
            className="scan-tickets-carousel"
            slideIndex={ticketIndex}
            afterSlide={ticketIndex => this.setState({ ticketIndex })}
            style={{ height: "70vw", maxHeight: "70vh" }}
          >
            {tickets.map((t, i) => (
              <TicketSlide key={i} ticket={t} />
            ))}
          </Carousel>
        </BaseOverlay>
      ) : null;
    }
  }
);



// WEBPACK FOOTER //
// ./src/app/components/overlays/scan-tickets.jsx